import React from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import { IconNameEnum } from "@b2bportal/core-themes";
import { Icon } from "@tenant/ui";
import styles from "./styles.module.scss";

interface FormErrorTextProps {
  error: React.ReactNode;
}

export const FormErrorText: React.FC<FormErrorTextProps> = ({ error }) => {
  const [block, cn] = useModuleBEM(styles, "FormErrorText");

  return (
    <div className={block}>
      <Icon
        className={cn("icon")}
        iconName={IconNameEnum.warning}
        useCurrentColor={false}
      />
      <span className={cn("text")}>{error}</span>
    </div>
  );
};
